import { render, staticRenderFns } from "./faculty.vue?vue&type=template&id=f1e0912a&"
import script from "./faculty.vue?vue&type=script&lang=ts&"
export * from "./faculty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports